import React from 'react';
import PropTypes from 'prop-types';
import DocumentLink from '@ertelecom/ui-react/components/documentLink';

import {
  Wrapper,
  Container,
  Title,
  Accordion,
  Document,
  DocumentWrapper,
} from './styled';

const SectionDocument = ({ title, items, props }) => (
  <Container {...props}>
    <Wrapper>
      <Title>{title}</Title>
      {
        items.map((item) => (item.documents.length > 0 && (
          <Accordion
            key={item.id}
            title={item.title}
            theme='simple'
          >
            <DocumentWrapper>
              {
                item.documents.map((document) => (
                  <Document key={document.id}>
                    <DocumentLink file={document} />
                  </Document>
                ))
              }
            </DocumentWrapper>
          </Accordion>
        )))
      }
    </Wrapper>
  </Container>
);

SectionDocument.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
};

export default SectionDocument;
